import fb from "@bd-core/firebase";

export const getStartTime = (teamCode) => {
    return fb.get(`${fb.sessionPath}/${teamCode}/startTime`);
};

export const startTimer = (startTime) => {
    return fb.update(`${fb.sessionPath}/`, { startTime });
};

export const pauseTimer = (accumulatedTime) => {
    return fb.update(`${fb.sessionPath}/`, { accumulatedTime, isPaused: true });
};

export const resumeTimer = (resumeTime) => {
    return fb.update(`${fb.sessionPath}/`, { startTime: resumeTime, isPaused: false });
};

export const stopTimer = (accumulatedTime) => {
    return fb.update(`${fb.sessionPath}/`, { isFinished: true, isPaused: false, accumulatedTime });
};

export const stopTimerFromPause = () => {
    return fb.update(`${fb.sessionPath}/`, { isFinished: true, isPaused: false });
};

export const mark = (data) => {
    return fb.update(fb.currentMarkPath, data);
};

export const getMarks = (teamCode) => {
    return fb.get(`${fb.sessionRootPath}/${teamCode}/marks`);
};

export const getSession = (teamCode) => {
    return fb.get(`${fb.sessionRootPath}/${teamCode}`);
};

export const getSessionById = (teamCode, sessionId) => {
    return fb.get(`${fb.sessionRootPath}/${teamCode}/${sessionId}`);
};

export const getAccumulatedTime = (teamCode) => {
    return fb.get(`${fb.sessionRootPath}/${teamCode}/accumulatedTime`);
};

export const finishGame = (teamCode) => {
    return fb.update(`${fb.sessionRootPath}/${teamCode}/`, { isFullyFinished: true });
};

export const selectSession = (sessionId) => {
    return fb.update(`${fb.sessionPath}/`, { sessionId: sessionId });
};